import axios from 'axios'
import TokenService from './tokenService'

const UserService = {
  get: async () => {
    try {
      const token = TokenService.getToken()
      const res = await axios.get('https://app.yanibasimdakaratay.com/api/genclik-merkezi-sinema-salonu-user', {
        headers: {
          Authorization: token,
        },
      })
      const result = res.data
      return result
    } catch (error) {
      return null
    }
  },
}

export default UserService
